<template>
  <div>
    <h3 class="mt-3">{{ $t("configuration.summary") }}</h3>


    <b-spinner
      v-if="loading"
      variant="primary"
      label="Spinning"
      style="display: block; margin: 16px auto"
    />

    <template v-if="items.length > 0">
      <h5>{{ $t("configuration.billOfMaterial") }}</h5>
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        :tbody-tr-class="rowClass"
        @row-clicked="toggleExpanded($event)"
      >
        <template v-slot:cell(position)="{ item }">
          {{ item.position }}
  
          <b-icon
            v-if="item.entries && item.entries.length > 0"
            style="cursor: pointer"
            :icon="item.expanded ? 'caret-down-fill' : 'caret-right-fill'"
          />
        </template>
        <template v-slot:cell(amount)="{ item }">
          {{ item.entries == null && item.depth > 0 ? item.amount : "" }}
        </template>
        <template v-slot:cell(totalWeight)="{ item }">
          {{ formatWeight(item.totalWeight) }}
        </template>
        <template v-slot:cell(totalPrice)="{ item }">
          {{ formatPrice(item.totalPrice) }}
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: new Set(),
    };
  },
  props: {
    moduleHover: Object,
    configuration: Object,
  },
  computed: {
    fields() {
      return [
        { key: "position", label: "", tdClass: "pos-col" },
        {
          key: "itemNumber",
          tdClass: "itemnumber-col",
          label: this.$t("bom.itemNumber"),
        },
        {
          key: "description",
          tdClass: "description-col",
          label: this.$t("configuration.description"),
        },
        {
          key: "amount",
          tdClass: "values-col",
          thClass: "values-col",
          label: this.$t("configuration.quantity"),
        },
        {
          key: "totalWeight",
          tdClass: "values-col",
          thClass: "values-col",
          label: this.$t("order.totalWeight"),
        },
        {
          key: "totalPrice",
          tdClass: "values-col",
          thClass: "values-col",
          label: this.$t("order.totalPrice"),
        },
      ];
    },
    currency() {
      return this.$store.state.configurations.configurationBom.currency;
    },
    loading() {
      return this.$store.state.configurations.configurationBom == null;
    },
    items() {
      if (this.$store.state.configurations.configurationBom == null) return [];
      const map = (entries, position = []) =>
        entries
          .map((entry, index) => {
            const entryPosition = [...position, index + 1];
            const positionString = entryPosition.join(".");

            const item = {
              ...entry,
              position: positionString,
              expanded: this.expanded.has(positionString) ,
              depth: position.length,
              hasChildren: entry.entries?entry.entries.length>0:false
            };

            return item.expanded
              ? [item, ...map(item.entries, entryPosition)]
              : item;
          })
          .flat();

      let m = map(this.$store.state.configurations.configurationBom.entries);
      m.push({
        totalRow: true,
        totalWeight: this.$store.state.configurations.configurationBom.totalWeight,
        totalPrice: this.$store.state.configurations.configurationBom.total,
      });
      return m;
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.depth === 0) return "group";
      if (item.depth === 1) return "subgroup";
      if (item.totalRow) return "total-row";
    },
    toggleExpanded(item) {
      if (this.expanded.has(item.position)) this.expanded.delete(item.position);
      else if (item.entries) this.expanded.add(item.position);
      this.expanded = new Set(this.expanded);
    },
    formatPrice(value) {
      if (value == null || this.currency == null) return "-";
      return Intl.NumberFormat(this.$i18n.locale, {
        style: "currency",
        currency: this.currency,
      }).format(value);
    },
    formatWeight(value) {
      if (value == null) return "-";
      return (
        value.toLocaleString(this.$i18n.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + " kg"
      );
    },
  },
};
</script>
<style >
.pos-col {
  width: 10%;
  white-space: nowrap;
  max-width: 60px;
}
.itemnumber-col {
  width: 8%;
  /* width: 100px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.description-col {
  width: 20%;
  min-width: 180px !important;
}
.values-col {
  width: 200px;
  text-align: right;
  /* min-width: 70px; */
}

tr.group td {
  /* border-bottom: 1px solid rgb(190, 190, 190); */
  font-weight: bold;
  font-size: 1em;
}
tr.subgroup td {
  color: rgba(0, 0, 0, 0.7);
  /* border-bottom: 1px solid rgb(190, 190, 190); */
}

tr.total-row td {
  border-top: 2px solid rgb(185, 185, 185);
  font-size: 1em;
  font-weight: bold;
}
.table-striped tbody tr.total-row:hover {
  background: none !important;
}
/* */
</style>
